import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Container, Form, Button } from "react-bootstrap"
import ModalAlert from "./ModalAlert"
import { fetchClient } from "../actions/cartActions"
import { FetchClientData } from "../actions/types"
import { RootState } from "../reducers"
import { useNavigate } from "react-router-dom";
import { setLogin } from "../actions/shopActions"

const INITIAL_MODAL_ALERT = {
  show: false,
  message: [] as string[],
  onSuccess: () => { },
  onClose: () => { }
}
const Login = () => {
  const client = useSelector((state: RootState) => state.cart.client);
  const isLogued = useSelector((state: RootState) => state.shop.isLogued);
  const [cell_phone, setCellPhone] = useState("")
  const [client_id, setClientId] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [initLogin, setInitLogin] = useState(true)
  const [modalAlert, setModalAlert] = useState(INITIAL_MODAL_ALERT)
  const dispatch: any = useDispatch()
  const navigate: any = useNavigate()

  const onFetchClient = async (request: FetchClientData) => {
    await dispatch(fetchClient(request))
  }

  const handleLogin = async () => {
    if (cell_phone.length !== 10 && client_id) {
      setModalAlert({
        ...modalAlert,
        show: true,
        message: ['WhatsApp incorrecto'],
        onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
        onClose: () => setModalAlert(INITIAL_MODAL_ALERT)
      })
    } else {
      setIsLoading(true)
      setInitLogin(false)
      await onFetchClient({ cell_phone, client_id })
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (client) {
      dispatch(setLogin({ isLogued: true }))
      localStorage.setItem('cell_phone', cell_phone)
      localStorage.setItem('client_id', client_id)
    } else {
      if (!isLoading && !initLogin) {
        setModalAlert({
          ...modalAlert,
          show: true,
          message: ['WhatsApp o número de cliente inválido'],
          onSuccess: () => setModalAlert(INITIAL_MODAL_ALERT),
          onClose: () => setModalAlert(INITIAL_MODAL_ALERT)
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, isLoading]);

  useEffect(() => {
    if (isLogued) {
      navigate(-1) || navigate("/")
    }
  }, [isLogued, navigate]);

  return <Container>
    <h2>Inicio de sesión</h2>
    <Form.Group className="col-md-4">
      <Form.Label>
        Ingresá tu número de WhatsApp (sin 15 y sin 0)
      </Form.Label>
      <Form.Control
        type="number"
        name="cellphone"
        id="cellphone"
        size="lg"
        placeholder="Ej. 3415654321"
        className="mb-2"
        defaultValue={cell_phone}
        onChange={(element) => setCellPhone(element.target.value)}
      />
    </Form.Group>
    <Form.Group className="col-md-4">
      <Form.Label>Numero de cliente</Form.Label>
      <Form.Control
        type="number"
        name="name"
        id="name"
        size="lg"
        className="mb-2"
        placeholder="Encontralo en el mail del pedido"
        defaultValue={client_id}
        onChange={(element) => setClientId(element.target.value)}
      />
    </Form.Group>
    <Button
      variant="secondary"
      size="lg"
      className="btn-block mb-2 mt-3 col-12 col-md-4"
      onClick={handleLogin}
      disabled={isLoading}
    >
      {isLoading ? "Procesando..." : "Ingresar"}
    </Button>
    <ModalAlert
      show={modalAlert.show}
      onClose={modalAlert.onClose}
      message={modalAlert.message}
      onSuccess={modalAlert.onSuccess}
    />
  </Container>
}
export default Login
